import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 서비스 워커 등록 코드가 있다면 제거하거나 주석 처리
// serviceWorker.register(); // 이 줄을 제거하거나 주석 처리
